import { notify } from '@Support/notify';

export const defaultCartConfig = {
    onAdd: function(messages, $jQueryTrigger) {
        for (const message of messages) {
            const $trigger = $jQueryTrigger.get(0);
            const notificationContent = message.type === 'success'
                ? __('add_to_cart_default_msg')
                : __('add_to_cart_default_error_msg');
            let notificationType = 'cartDefaultButton';

            if ($trigger.offsetWidth < 100) {
                notificationType = message.type === 'success' ? 'cartRoundedSuccessButton' : 'cartRoundedErrorButton';
            }

            notify({
                type: 'headerCart',
                content: message.msg
            });
            notify({
                type: notificationType,
                content: notificationContent,
                $target: $trigger
            });
        }
    }
}